import React, { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';

import ModalContext from './ModalContext';

import './Overlay.module.css';

const ModalRoot = () => {
  const { component: Component, props, overlayType, hideModal } = useContext(
    ModalContext
  );
  const { t } = useTranslation();

  if (!Component) {
    return null;
  }

  const overlay =
    overlayType === 'touchclose' ? (
      <div
        styleName="overlay"
        onMouseEnter={hideModal}
        onTouchStart={hideModal}
      />
    ) : (
      <InteractiveDiv
        styleName="blind"
        handler={hideModal}
        aria-label={t('Close modal window')}
      />
    );

  return (
    <Fragment>
      <Component {...props} />
      {overlay}
    </Fragment>
  );
};

export default ModalRoot;
